import { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import api from "../constant/api";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Html5QrcodeScanner } from "html5-qrcode";
import { useMenuPermission } from "../hooks/useMenuPermission";

export default function Products() {

  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const [search, setSearch] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const [zoomStyle, setZoomStyle] = useState({});
  const [showFilter, setShowFilter] = useState(false);

  const [showScanner, setShowScanner] = useState(false);

  const navigate = useNavigate();

     const MENU_ID = 2; 
    const { permissions, loading } = useMenuPermission(MENU_ID);

  useEffect(() => {
  if (showScanner) {
    const scanner = new Html5QrcodeScanner(
      "qr-reader",
      { fps: 10, qrbox: 250 },
      false
    );

    scanner.render(
      (decodedText) => {
        // ✅ QR SUCCESS
        console.log("QR Code:", decodedText);

        // 👉 set search using product_code
        setSearch(decodedText);
        setShowScanner(false);
        scanner.clear();
      },
      (error) => {
        console.log(error);
      }
    );

    return () => scanner.clear();
  }
}, [showScanner]);

  useEffect(() => {
    api.get("/Product/getProduct")
      .then(res => {
        console.log("API DATA:", res.data.data);
        setProducts(res.data.data || []);
      })
      .catch(err => console.log(err));
  }, []);

  // 🔍 FILTER

    if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-gray-500 font-medium">Checking permissions...</p>
      </div>
    );
  }

  let filteredProducts = products.filter((item) =>
  item.product_name?.toLowerCase().includes(search.toLowerCase()) ||
  item.product_code?.toLowerCase().includes(search.toLowerCase())
);

  filteredProducts = filteredProducts.filter((item) => {
    const price = Number(item.price);
    return (
      (minPrice === "" || price >= Number(minPrice)) &&
      (maxPrice === "" || price <= Number(maxPrice))
    );
  });

  // 🔽 SORT
  if (sortOrder === "low") {
    filteredProducts.sort((a, b) => a.price - b.price);
  } else if (sortOrder === "high") {
    filteredProducts.sort((a, b) => b.price - a.price);
  }

  // 📄 PAGINATION
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentProducts = filteredProducts.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

  // 🔍 ZOOM
  const handleZoom = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    setZoomStyle({ backgroundPosition: `${x}% ${y}%` });
  };

  const handleToggle = (item) => {
  const newStatus = item.published === 1 ? 0 : 1;

  api.post("/Product/togglePublish", {
    product_id: item.product_id,
    published: newStatus
  })
    .then(() => {

      // 🔥 update UI instantly
      setProducts(prev =>
        prev.map(p =>
          p.product_id === item.product_id
            ? { ...p, published: newStatus }
            : p
        )
      );

    })
    .catch(err => console.log(err));
};
const getPagination = (currentPage, totalPages) => {
  const pages = [];

  if (totalPages <= 7) {
    // show all pages
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
  } else {
    pages.push(1); // always show first

    if (currentPage > 3) {
      pages.push("...");
    }

    let start = Math.max(2, currentPage - 1);
    let end = Math.min(totalPages - 1, currentPage + 1);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (currentPage < totalPages - 2) {
      pages.push("...");
    }

    pages.push(totalPages); // always show last
  }

  return pages;
};
  return (
    <div>

   {/* ================= HEADER ================= */}
<div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-5">

  {/* TITLE */}
  <div>

    <h1 className="text-2xl md:text-3xl font-bold text-gray-800">
      Product List
    </h1>

    <p className="text-sm text-gray-500 mt-1">
      Manage all products easily
    </p>

  </div>

  {/* ACTION BUTTONS */}
  <div className="flex items-center gap-2 flex-wrap">

    {/* FILTER */}
    <button
      className="md:hidden bg-gray-800 hover:bg-gray-900 text-white px-4 py-2 rounded-xl shadow text-sm"
      onClick={() => setShowFilter(true)}
    >
      ⚙️ Filter
    </button>

    {/* SCAN */}
    <button
      className="md:hidden bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-xl shadow text-sm"
      onClick={() => setShowScanner(true)}
    >
      📷 Scan QR
    </button>

    {/* DESKTOP ADD */}
         {permissions?.canAdd && (
    <button
      onClick={() => navigate("/add-product")}
      className="hidden md:flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-5 py-3 rounded-xl shadow-lg transition"
    >
      <FaPlus />
      Add Product
    </button>
 )}
  </div>

</div>

{/* ================= DESKTOP FILTER ================= */}
<div className="hidden md:flex items-center gap-3 mb-5 flex-wrap bg-white p-4 rounded-2xl shadow border border-gray-100">

  {/* SEARCH */}
  <div className="flex-1 min-w-[220px]">

    <input
      type="text"
      placeholder="Search product or code..."
      value={search}
      onChange={(e) => {
        setSearch(e.target.value);
        setCurrentPage(1);
      }}
      className="w-full border border-gray-200 focus:border-blue-500 outline-none px-4 py-3 rounded-xl"
    />

  </div>

  {/* MIN PRICE */}
  <input
    type="number"
    placeholder="Min Price"
    value={minPrice}
    onChange={(e) => setMinPrice(e.target.value)}
    className="border border-gray-200 focus:border-blue-500 outline-none px-4 py-3 rounded-xl w-36"
  />

  {/* MAX PRICE */}
  <input
    type="number"
    placeholder="Max Price"
    value={maxPrice}
    onChange={(e) => setMaxPrice(e.target.value)}
    className="border border-gray-200 focus:border-blue-500 outline-none px-4 py-3 rounded-xl w-36"
  />

  {/* SORT */}
  <select
    value={sortOrder}
    onChange={(e) => setSortOrder(e.target.value)}
    className="border border-gray-200 focus:border-blue-500 outline-none px-4 py-3 rounded-xl"
  >
    <option value="">Sort By</option>
    <option value="low">Price Low → High</option>
    <option value="high">Price High → Low</option>
  </select>

</div>

{/* ================= MOBILE FLOAT BUTTON ================= */}
<button
  onClick={() => navigate("/add-product")}
  className="fixed bottom-6 right-5 bg-blue-600 hover:bg-blue-700 text-white w-14 h-14 flex items-center justify-center rounded-full shadow-2xl md:hidden z-50"
>
  <FaPlus size={18} />
</button>

    {/* ================= DESKTOP TABLE ================= */}
<div className="hidden md:block overflow-x-auto bg-white rounded-2xl shadow border border-gray-100">

  <table className="min-w-full text-sm">

    <thead className="bg-gradient-to-r from-gray-900 to-gray-700 text-white">
      <tr>
        <th className="px-4 py-3 text-left">Image</th>
        <th className="px-4 py-3 text-left">Product</th>
        <th className="px-4 py-3 text-left">Code</th>
        <th className="px-4 py-3 text-center">Price</th>
        <th className="px-4 py-3 text-center">Qty</th>
        <th className="px-4 py-3 text-center">Status</th>
        <th className="px-4 py-3 text-center">Action</th>
      </tr>
    </thead>

    <tbody>

      {currentProducts.map((item, i) => (

        <tr
          key={i}
          className="border-b hover:bg-gray-50 transition"
        >

          {/* IMAGE */}
          <td className="px-4 py-3">

            <img
              src={`https://akceramicworldadmin.unitdtechnologies.com/uploads/${item.images}`}
              alt=""
              className="w-16 h-16 rounded-xl object-cover border cursor-pointer"
              onClick={() => {
                setSelectedProduct([...filteredProducts]);
                setCurrentIndex(indexOfFirst + i);
              }}
            />

          </td>

          {/* PRODUCT */}
          <td className="px-4 py-3">

            <h2 className="font-semibold text-gray-800">
              {item.product_name}
            </h2>

          </td>

          {/* CODE */}
          <td className="px-4 py-3">

            <span className="bg-gray-100 px-3 py-1 rounded-lg text-xs">
              {item.product_code}
            </span>

          </td>

          {/* PRICE */}
          <td className="px-4 py-3 text-center">

            <p className="font-bold text-blue-600">
              ₹{item.price}
            </p>

          </td>

          {/* QTY */}
          <td className="px-4 py-3 text-center">

            <span className="font-medium">
              {item.qty}
            </span>

          </td>

          {/* STATUS */}
          <td className="px-4 py-3 text-center">

            <div
              onClick={() => handleToggle(item)}
              className={`w-12 h-6 flex items-center rounded-full p-1 cursor-pointer transition mx-auto
              ${
                item.published
                  ? "bg-green-500"
                  : "bg-gray-400"
              }`}
            >
              <div
                className={`bg-white w-4 h-4 rounded-full shadow transform transition
                ${
                  item.published
                    ? "translate-x-6"
                    : ""
                }`}
              />
            </div>

          </td>

          {/* ACTION */}
          <td className="px-4 py-3 text-center">

            <button
              onClick={() =>
                navigate(`/edit-product/${item.product_id}`)
              }
              className="bg-yellow-400 hover:bg-yellow-500 text-white px-4 py-2 rounded-xl text-xs shadow"
            >
              ✏ Edit
            </button>

          </td>

        </tr>

      ))}

    </tbody>

  </table>

</div>

{/* ================= MOBILE CARD VIEW ================= */}
<div className="md:hidden space-y-3">

  {currentProducts.map((item, i) => (

    <motion.div
      key={i}
      initial={{ opacity: 0, y: 15 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white border border-gray-100 rounded-2xl shadow-sm overflow-hidden"
    >

      <div className="flex gap-3 p-3">

        {/* IMAGE */}
        <img
          src={`https://akceramicworldadmin.unitdtechnologies.com/uploads/${item.images}`}
          alt=""
          className="w-24 h-24 rounded-2xl object-cover border cursor-pointer"
          onClick={() => {
            setSelectedProduct([...filteredProducts]);
            setCurrentIndex(indexOfFirst + i);
          }}
        />

        {/* DETAILS */}
        <div className="flex-1 min-w-0">

          {/* TOP */}
          <div className="flex justify-between gap-2">

            <div className="min-w-0">

              <h2 className="font-semibold text-[14px] text-gray-800 leading-tight truncate">
                {item.product_name}
              </h2>

              <p className="text-[11px] text-gray-500 mt-1">
                Code : {item.product_code}
              </p>

            </div>

            {/* STATUS */}
            <div
              onClick={() => handleToggle(item)}
              className={`w-10 h-5 flex items-center rounded-full p-1 cursor-pointer transition shrink-0
              ${
                item.published
                  ? "bg-green-500"
                  : "bg-gray-400"
              }`}
            >
              <div
                className={`bg-white w-4 h-4 rounded-full transition
                ${
                  item.published
                    ? "translate-x-5"
                    : ""
                }`}
              />
            </div>

          </div>
            {/* PRICE */}
          <div className="mt-2">

            <p className="text-[11px] text-gray-400">
              Branch
            </p>

            <p className="font-medium text-sm">
                {item.branch}
              </p>

          </div>

          {/* PRICE */}
          <div className="mt-2">

            <p className="text-[11px] text-gray-400">
              Price
            </p>

            <h3 className="text-blue-600 font-bold text-lg leading-none">
              ₹{item.price}
            </h3>

          </div>

          {/* QTY */}
          <div className="mt-2 flex items-center justify-between">

            <div>

              <p className="text-[11px] text-gray-400">
                Quantity
              </p>

              <p className="font-medium text-sm">
                {item.qty}
              </p>

            </div>
            <div>

              <p className="text-[11px] text-gray-400">
                PCS
              </p>

              <p className="font-medium text-sm">
                {item.pic}
              </p>

            </div>

            {/* EDIT BUTTON */}
            <button
              onClick={() =>
                navigate(`/edit-product/${item.product_id}`)
              }
              className="bg-yellow-400 hover:bg-yellow-500 text-white px-4 py-2 rounded-xl text-xs font-semibold shadow"
            >
              ✏ Edit
            </button>

          </div>

        </div>

      </div>

    </motion.div>

  ))}

</div>

      {/* PAGINATION */}
      <div className="flex justify-center items-center mt-6 gap-2 flex-wrap">

  {/* PREV */}
  <button
    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
    disabled={currentPage === 1}
    className="px-3 py-2 rounded-lg border bg-white hover:bg-gray-100 disabled:opacity-50"
  >
    ◀
  </button>

  {/* PAGE NUMBERS */}
  {getPagination(currentPage, totalPages).map((page, index) => (

    page === "..." ? (
      <span key={index} className="px-2">...</span>
    ) : (
      <button
        key={index}
        onClick={() => setCurrentPage(page)}
        className={`px-3 py-2 rounded-lg border transition ${
          currentPage === page
            ? "bg-blue-500 text-white"
            : "bg-white hover:bg-gray-100"
        }`}
      >
        {page}
      </button>
    )
  ))}

  {/* NEXT */}
  <button
    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
    disabled={currentPage === totalPages}
    className="px-3 py-2 rounded-lg border bg-white hover:bg-gray-100 disabled:opacity-50"
  >
    ▶
  </button>

</div>
       <AnimatePresence>
  {showFilter && (
    <>

      {/* BACKDROP */}
      <motion.div
        className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[9998]"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={() => setShowFilter(false)}
      />

      {/* FILTER MODAL */}
      <motion.div
        initial={{ y: "100%" }}
        animate={{ y: 0 }}
        exit={{ y: "100%" }}
        transition={{
          type: "spring",
          damping: 25,
          stiffness: 250
        }}
        className="fixed bottom-0 left-0 w-full bg-white rounded-t-[30px] z-[9999] overflow-hidden shadow-2xl md:hidden"
      >

        {/* TOP BAR */}
        <div className="flex justify-center pt-3">
          <div className="w-14 h-1.5 bg-gray-300 rounded-full"></div>
        </div>

        {/* HEADER */}
        <div className="flex justify-between items-center px-5 py-4 border-b">

          <div>
            <h2 className="text-xl font-bold text-gray-800">
              Filters
            </h2>

            <p className="text-sm text-gray-500">
              Search & sort products
            </p>
          </div>

          <button
            onClick={() => setShowFilter(false)}
            className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center text-gray-600"
          >
            ✕
          </button>

        </div>

        {/* BODY */}
        <div className="p-5 space-y-4 max-h-[70vh] overflow-y-auto">

          {/* SEARCH */}
          <div>

            <label className="text-sm font-semibold text-gray-700 mb-2 block">
              Search Product
            </label>

            <input
              type="text"
              placeholder="Search by product name or code..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none px-4 py-3 rounded-2xl text-sm"
            />

          </div>

          {/* PRICE */}
          <div className="grid grid-cols-2 gap-3">

            <div>

              <label className="text-sm font-semibold text-gray-700 mb-2 block">
                Min Price
              </label>

              <input
                type="number"
                placeholder="₹ 0"
                value={minPrice}
                onChange={(e) => setMinPrice(e.target.value)}
                className="w-full border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none px-4 py-3 rounded-2xl text-sm"
              />

            </div>

            <div>

              <label className="text-sm font-semibold text-gray-700 mb-2 block">
                Max Price
              </label>

              <input
                type="number"
                placeholder="₹ 9999"
                value={maxPrice}
                onChange={(e) => setMaxPrice(e.target.value)}
                className="w-full border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none px-4 py-3 rounded-2xl text-sm"
              />

            </div>

          </div>

          {/* SORT */}
          <div>

            <label className="text-sm font-semibold text-gray-700 mb-2 block">
              Sort Products
            </label>

            <select
              value={sortOrder}
              onChange={(e) => setSortOrder(e.target.value)}
              className="w-full border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none px-4 py-3 rounded-2xl text-sm bg-white"
            >
              <option value="">Select Sorting</option>
              <option value="low">Price Low → High</option>
              <option value="high">Price High → Low</option>
            </select>

          </div>

        </div>

        {/* FOOTER */}
        <div className="border-t p-4 bg-white flex gap-3">

          {/* RESET */}
          <button
            onClick={() => {
              setSearch("");
              setMinPrice("");
              setMaxPrice("");
              setSortOrder("");
            }}
            className="w-1/2 py-3 rounded-2xl border border-gray-300 text-gray-700 font-semibold"
          >
            Reset
          </button>

          {/* APPLY */}
          <button
            onClick={() => {
              setShowFilter(false);
              setCurrentPage(1);
            }}
            className="w-1/2 py-3 rounded-2xl bg-gradient-to-r from-blue-600 to-blue-500 text-white font-semibold shadow-lg"
          >
            Apply Filters
          </button>

        </div>

      </motion.div>

    </>
  )}
</AnimatePresence>

      {/* ✅ IMAGE MODAL (FIXED) */}
      <AnimatePresence>
        {selectedProduct && selectedProduct.length > 0 && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[9999]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >

            <motion.div
              className="bg-white p-6 rounded-xl max-w-md w-full relative"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
            >

              {/* Close */}
              <button
                className="absolute top-2 right-2 text-xl"
                onClick={() => setSelectedProduct(null)}
              >
                ✖
              </button>

              {/* SAFE CHECK */}
              {selectedProduct[currentIndex] && (
                <>
                  {/* ZOOM IMAGE */}
                  <div
                    onMouseMove={handleZoom}
                    onMouseLeave={() => setZoomStyle({})}
                    className="w-full h-64 rounded overflow-hidden"
                    style={{
                      backgroundImage: `url(https://akceramicworldadmin.unitdtechnologies.com/uploads/${selectedProduct[currentIndex].images})`,
                      backgroundSize: zoomStyle.backgroundPosition ? "200%" : "contain",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: zoomStyle.backgroundPosition || "center",
                    }}
                  />

                  {/* DETAILS */}
                  <div className="mt-4 text-center">
                    <h2 className="font-bold">
                      {selectedProduct[currentIndex].product_name}
                    </h2>
                    <p>₹{selectedProduct[currentIndex].price}</p>
                    <p>Qty: {selectedProduct[currentIndex].qty}</p>
                  </div>

                  {/* SLIDER */}
                  <div className="flex justify-between mt-4">
                    <button
                      onClick={() =>
                        setCurrentIndex(
                          currentIndex === 0
                            ? selectedProduct.length - 1
                            : currentIndex - 1
                        )
                      }
                    >
                      ◀
                    </button>

                    <button
                      onClick={() =>
                        setCurrentIndex(
                          currentIndex === selectedProduct.length - 1
                            ? 0
                            : currentIndex + 1
                        )
                      }
                    >
                      ▶
                    </button>
                  </div>
                </>
              )}

            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
      
         <AnimatePresence>
  {showScanner && (
    <>
      <motion.div
        className="fixed inset-0 bg-black bg-opacity-70 z-[9998]"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={() => setShowScanner(false)}
      />

      <motion.div
        className="fixed bottom-0 left-0 w-full bg-white p-4 rounded-t-2xl z-[9999]"
        initial={{ y: "100%" }}
        animate={{ y: 0 }}
        exit={{ y: "100%" }}
      >
        <h2 className="font-bold mb-3 text-center">Scan QR Code</h2>

        <div id="qr-reader" />

        <button
          onClick={() => setShowScanner(false)}
          className="mt-4 w-full bg-red-500 text-white py-2 rounded"
        >
          Close
        </button>
      </motion.div>
    </>
  )}
</AnimatePresence>
    </div>
  );
}